import React from "react";
import { ISearchBreadCrumbProps } from "./SearchBreadCrumbProps";
import CustomBreadCrumb from "../CustomBreadCrumb/CustomBreadCrumb";

const SearchBreadCrumb: React.FC<ISearchBreadCrumbProps> = (props) => {
  const crumbs = [
    {
      text: "Select Room",
      page: "",
      id: "select-room",
    },
    {
      text: "Guest Details",
      page: "/checkout",
      id: "guest-details",
    },
    {
      text: "Checkout",
      page: "/checkout",
      id: "checkout",
    },
  ];
  if (props.step === "2") {
    //* This will hide breadcrumb for hotel pages.
    return <div></div>;
  }
  return (
    <CustomBreadCrumb
      crumbs={crumbs}
      step={props.step}
      location={props.location}
      hotel={props.hotel}
      handleGoToGuestDetailsStep={props.handleGoToGuestDetailsStep}
    ></CustomBreadCrumb>
  );
};

export default SearchBreadCrumb;
